var React = require('react');

function DownChevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M3.707 5.293L2.293 6.707 8 12.414l5.707-5.707-1.414-1.414L8 9.586z"}));
}

DownChevron.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = DownChevron;

DownChevron.default = DownChevron;
